import React, { Component } from 'react'
import { t } from '../locales/translations'
import eu_logo from '../images/eu_logo.png'
import uzuvrh_logo from '../images/uzuvrh_logo.png'
import zagreb_logo from '../images/zagreb_logo.png'
// import riku_logo from '../images/riku_logo.png'
import finland_logo from '../images/finland_logo.png'
import kljp_logo from '../images/kljp_logo.png'
import gong_logo from '../images/gong_logo.png'
import cms_logo from '../images/cms_logo.png'
import centri_znanja_logo from '../images/centri_znanja_logo.png'
import zaklada_logo from '../images/zaklada_logo.png'
import norway_grants from '../images/norway_grants.png'
import fah_eu from '../images/fah_eu.jpeg'
import pride_logo from '../images/pride_logo.png'
import hrhf_logo from '../images/hrhf_logo.png'
class ScreenText extends Component {

  getTexts = (language) => [{
    title: t(language, 'aboutHateSpeechTitle'),
    content: <div className="faq"><h4>{t(language, 'whatIsHateSpeech')}</h4>
              <p>{t(language, 'hateSpeechDef')}</p>
              <p>{t(language, 'spreadIntolerance')}</p>

              <h4>{t(language, 'whyHarmful')}</h4>
              <p>{t(language, 'harmfulEffects')}</p>
              <p>{t(language, 'freeSpeechAbuse')}</p>

              <h4>{t(language, 'whyReport')}</h4>
              <p>{t(language, 'reportContribution')}</p>
              <p>{t(language, 'reportBenefit')}</p></div>
  },{
    title: t(language, 'howToReportTitle'),
    content: <div>
              <p>{t(language, 'submissionProcess')}</p>
              <p>{t(language, 'detailedInfo')}</p>
              <p><strong>{t(language, 'important')}</strong> {t(language, 'emailImportance')}</p>
             </div>,
  },{
    title: t(language, 'faqTitle'),
    content: <div className="faq">
              <h4>{t(language, 'faqQ1')}</h4>
              <p>{t(language, 'pageService')}</p>
              <p><strong>{t(language, 'reportHate')}</strong> - {t(language, 'reportHateSpeechExpl')}</p>
              <p><strong>{t(language, 'reportHateCrime')}</strong> - {t(language, 'reportHateCrimesExpl')}</p>
              <p>{t(language, 'reportHateCrimesExpl2')}</p>
              <p>{t(language, 'reportHateCrimesExpl3')}</p>

              <h4>{t(language, 'faqQ2')}</h4>
              <p>{t(language, 'faqQ2a')}</p>
              <p>{t(language, 'faqQ2b')}</p>
              <ul>
                <li>{t(language, 'faqQ2c1')}</li>
                <li>{t(language, 'faqQ2c2')}</li>
                <li>{t(language, 'faqQ2c3')}</li>
                <li>{t(language, 'faqQ2c4')}</li>
              </ul>
              <p>{t(language, 'faqQ2d')}</p>
              <p>{t(language, 'faqQ2e')}</p>

              <h4>{t(language, 'faqQ3')}</h4>
              <p>{t(language, 'faqQ3a')}</p>
              <ul>
                <li>{t(language, 'faqQ3b1')}</li>
                <li>{t(language, 'faqQ3b2')}</li>
                <li>{t(language, 'faqQ3b3')}</li>
              </ul>
              <p>{t(language, 'faqQ3c')}</p>

              <h4>{t(language, 'faqQ4')}</h4>
              <p>{t(language, 'freedomImportant')}</p>
              <p>{t(language, 'freedomLimited')}</p>

              <h4>{t(language, 'faqQ5')}</h4>
              <p>{t(language, 'faqQ5a')}</p>
              <p>{t(language, 'faqQ5b')}</p>

              <h4>{t(language, 'faqQ6')}</h4>
              <p>{t(language, 'privacyNo')}</p>

              <h4>{t(language, 'faqQ7')}</h4>
              <p>{t(language, 'faqQ7a')}</p>

              <h4>{t(language, 'faqQ8')}</h4>
              <p>{t(language, 'faqQ8a')} <a href="https://bit.ly/36okD2t">https://bit.ly/36okD2t</a>.</p>

              <h4>{t(language, 'faqQ9')}</h4>
              <p>{t(language, 'faqQ9a')}</p>
              <ul>
                <li>{t(language, 'faqQ9b1')}</li>
                <li>{t(language, 'faqQ9b2')}</li>
                <li>{t(language, 'faqQ9b3')}</li>
              </ul>
              <p>{t(language, 'faqQ9c')}</p>
              <p>{t(language, 'faqQ9d')}</p>
             </div>
  },{
    title: t(language, 'aboutUsTitle'),
    content: <div>
                <div>
                  <a href="https://eeagrants.org/Who-we-are/Norway-Grants"><img width="300" src={norway_grants} alt="Fondovi Europskog gospodarskog prostora i Kraljevine Norveške" /></a>
                </div>
                <br />
                <p>{t(language, 'aboutUsContent')}</p>
                <p>{t(language, 'aboutUsContent2')}</p>
                <p>{t(language, 'aboutUsContent3')}</p>
                <div className="logos">
                  <a href="https://ec.europa.eu/info/policies/justice-and-fundamental-rights_en" id="eu_logo" ><img src={eu_logo} alt="logotip Europske Unije" /></a>
                  <a href="https://udruge.gov.hr/" id="uzuvrh_logo" ><img src={uzuvrh_logo} alt="logotip Ureda za udruge Vlade Republike Hrvatske" /></a>
                  <a href="https://www.zagreb.hr/"><img src={zagreb_logo} alt="Logotip grada Zagreba" /></a>
                  <a href="https://oikeusministerio.fi/en/frontpage"><img src={finland_logo} alt="Logotip Ministarstva pravosuđa Republike Finske" /></a>
                  <a href="http://www.kucaljudskihprava.hr/"><img src={kljp_logo} alt="Logotip Kuće ljudskih prava" /></a>
                  <a href="https://www.gong.hr/hr/"><img src={gong_logo} alt="Logotip organizacije GONG" /></a>
                  <a href="https://www.cms.hr/"><img src={cms_logo} alt="Logotip organizacije Centar za mirovne studije" /></a>
                  <a href="https://zaklada.civilnodrustvo.hr/category/104/subcategory/309"><img src={centri_znanja_logo} alt="Logotip Centara znanja za društveni razvoj" /></a>

                  <a href="https://humanrightshouse.org/"><img src={hrhf_logo} alt="Human Rights House Foundation" /></a>
                  <a href="https://zaklada.civilnodrustvo.hr/" id="zaklada_logo"><img src={zaklada_logo} alt="Logotip Centara znanja za društveni razvoj" /></a>
                  <a href="https://zagreb-pride.net/"><img src={pride_logo} alt="ZG pride" /></a>

                  <img src={fah_eu} alt="Facts against hate" />
                </div>
                <p>{t(language, 'aboutUsDisclaimer1')}</p>
                <p>{t(language, 'aboutUsDisclaimer2')}</p>
                <p>{t(language, 'aboutUsDisclaimer3')}</p>
              </div>

  },{
    title: t(language, 'aboutHateCrimesTitle'),
    content: <div>
      <p>{t(language, 'aboutHateCrimesContent')}</p>
      <p>{t(language, 'aboutHateCrimesContent2')}</p>
      <p>{t(language, 'aboutHateCrimesContent3')}</p>
      <p>{t(language, 'aboutHateCrimesContent4')}</p>
    </div>
  }]

  render() {
    const { language } = this.props
    const texts = this.getTexts(language)

    return (
      <main>
        <h3>{texts[this.props.text - 1].title}</h3>
        {texts[this.props.text - 1].content}
      </main>
    );
  }
}

export default ScreenText;
